import { BaseEntityDto } from '@fleet-beat/core';
import { DriverDto } from '../tenants';
import { SafeHtml } from '@angular/platform-browser';

export interface FmcsaReportsDto extends BaseEntityDto {
  id?: string;
  driver?: DriverDto;
  comment?: string;
  startedAt?: string;
  endedAt?: string;
  processedAt?: string;
  submissionId?: string;
}

export type FmcsaValidationErrorType = 'Error' | 'Warning' | 'Information';

export interface FmcsaValidationError {
  Detail: string | SafeHtml;
  End: number;
  ErrorType: FmcsaValidationErrorType;
  Line: number;
  Message: string;
  Start: number;
}

export interface FmcsaValidationDto {
  status: FmcsaValidationErrorType;
  rawRes: {
    Broadcast: string;
    ErrorCount: number;
    Errors: {
      ValidationError: FmcsaValidationError[];
    };
    Status: FmcsaValidationErrorType;
    SubmissionId: string;
  };
}
